import React from 'react'
import { Dimmer, Loader } from 'semantic-ui-react'

const ModalLoadingComponent: React.FC<{ inverted?: boolean, content?: string, active?: boolean }> = ({
  inverted = true,
  content,
  active
}) => {
  return (
    <Dimmer active={active} inverted={inverted}>
      <Loader content={content} />
    </Dimmer>
  )
}

export default ModalLoadingComponent;